import React from 'react'
import PropTypes from 'prop-types'

import { Checkbox } from 'react-bootstrap'
import Util from './Util'
import { NumericInput, LabelGroup, Flex } from '~/views';

export default class LinearInterpolatorEditor extends React.Component {

  static TYPE = 'linear'

  static propTypes = {
    interpolator : PropTypes.object,
    attributeType : PropTypes.object,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.changePath = Util.ChangePath.bind( this )
  }

  render() {
    const { interpolator : mdl } = this.props
    if ( mdl == null ) {
      return <div />
    }

    return (
      <Flex variant="vSpace" direction="column" align="stretch">

        <LabelGroup>
          <label>Update every</label>
          <div>
            <NumericInput
              hint="Seconds..." 
              value={mdl.update == null ? 0 : mdl.update / 1000}
              float
              size={5}
              min={0}
              onChange={( v, err ) => { this.changePath( 'update', typeof v === 'number' ? v * 1000 : v, err ) }} />
            <label style={{ margin : '0 8px' }}> seconds</label>
          </div>
        </LabelGroup>
        <LabelGroup>
          <label />
          <Checkbox style={{ margin : '0' }} checked={mdl.addNoise} onChange={( e ) => { this.changePath( 'addNoise', e.target.checked, false ) }}>
            Add Noise 
          </Checkbox>
        </LabelGroup>
        { !mdl.addNoise ? null :
          (
            <LabelGroup>
              <label>Between</label>
              <div>
                <NumericInput
                  hint="From..." 
                  style={{ width : '80px' }}
                  size={5}
                  value={mdl.range1}
                  float
                  onChange={( v, err ) => { this.changePath( 'range1', v, err ) }} />
        
                <label style={{ margin : '0 8px' }}>and</label>
                <NumericInput
                  hint="To..." 
                  style={{ width : '80px' }}
                  size={5}
                  value={mdl.range2}
                  float
                  onChange={( v, err ) => { this.changePath( 'range2', v, err ) }} />
              </div>
            </LabelGroup>
          )}
      </Flex>
    ) 
  }
}
